// extracted by mini-css-extract-plugin
module.exports = {"content":"OpinionsForApprovalTable_content__32gT9"};